import type {
  FillCompanySurveyMutation,
  FillCompanySurveyMutationVariables
} from './__generated__/FillCompanySurveyMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  FillCompanySurveyMutation,
  FillCompanySurveyMutationVariables
> = gql`
  mutation FillCompanySurveyMutation($input: FillCompanySurveyInput!) {
    fillCompanySurvey(input: $input) {
      survey {
        createdAt
        employee {
          id
          firstName
          lastName
        }
        id
        participant {
          id
        }
        surveyType
      }
    }
  }
`

export function fillCompanySurveyMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      FillCompanySurveyMutation,
      FillCompanySurveyMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
